var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"content"}},[_c('Nav'),_c('Hero'),_c('Split'),_c('Avis',{staticClass:"desktop-avis"}),_c('Horaires'),_c('PreviewVentes'),_c('Ventes'),_c('Prix'),_c('Marques'),_c('Avis',{staticClass:"mobile-avis"}),_c('Contact')],1)}
var staticRenderFns = []

export { render, staticRenderFns }